/** Right arrow used on the home Hero CTA; pair with `ctaHoverCss` for the hover nudge. */
export function CtaArrow({ className = 'w-4 h-4' }: { className?: string }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      style={{ flexShrink: 0, display: 'block' }}
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
    </svg>
  );
}
